import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CustomvalidationService {

  constructor(private http: HttpClient) { }

  redirectDomainValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = new RegExp('^[a-z0-9\-]+$');
      const valid = regex.test(control.value);
      return valid ? null : { invalidRedirectDomain: true };
    };
  }

  domainValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      var SplitDomain = control.value.split(".")[0]
      const regex = new RegExp('^[a-z0-9\-]+$');
      const valid = regex.test(SplitDomain);
      return valid ? null : { invalidDomain: true };
    };
  }

  patternValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');
      const valid = regex.test(control.value);
      return valid ? null : { invalidPassword: true };
    };
  }

  BarcodepatternValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = new RegExp('^[A-Z0-9]+$'); // Allow only uppercase letters, lowercase letters, and numbers
      const valid = regex.test(control.value);
      return valid ? null : { invalidPattern: true };
    };
  }

  MatchPassword(password: string, confirmPassword: string) {
    return (formGroup: UntypedFormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors.passwordMismatch) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }

      return true;
    }
  }

  userNameValidator(userControl: AbstractControl) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (this.validateUserName(userControl.value)) {
          resolve({ userNameNotAvailable: true });
        } else {
          resolve(null);
        }
      }, 1000);
    });
  }

  validateUserName(userName: string) {
    const UserList = ['ankit', 'admin', 'user', 'superuser'];
    return (UserList.indexOf(userName) > -1);
  }

  domainExist(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      return this.getDomain(control.value)
        .pipe(
          debounceTime(200),
          distinctUntilChanged(),
          take(1),
          map((data: any) => {
            return data.result ? { domainExist: true } : null;
          })
        );
      // return domainService
      //   .checkIfUsernameExists(control.value)
      //   .pipe(
      //     map((result: boolean) =>
      //       result ? { usernameAlreadyExists: true } : null
      //     )
      //   );
    };
  }

  getDomain(domain: string) {
    return this.http.get<any>(environment.HTTP+environment.API_URL+'/api/domain', {
      params: {
        domain: domain,
      }
    });
  }
}

// export class DomainValidator {
//   static createValidator(group: FormGroup): AsyncValidatorFn {
//     return (control: AbstractControl): Observable<ValidationErrors> => {
//       return domainService
//         .checkIfUsernameExists(control.value)
//         .pipe(
//           map((result: boolean) =>
//             result ? { usernameAlreadyExists: true } : null
//           )
//         );
//     };
//   }
// }
